import React, { useEffect, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';

import ClubRedirect from 'club/SignupRedirect';
import ModalListener from 'common/components/modal/ModalListener';
import { getCustomer } from 'redux/customer/actions';
import { getResourceBundle } from 'redux/localization/actions';
import { getForWeb } from 'redux/settings/actions';
import Widgets from 'widgets/Widgets';

import InvalidGateway from './InvalidGateway';

const NoApp = () => {
  const [isInvalidGateway, setIsInvalidGateway] = useState(false);
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting.data);
  const resourceBundle = useSelector((state) => state.localization.data);

  useEffect(() => {
    const onError = () => {
      setIsInvalidGateway(true);
    };
    if (!setting) {
      dispatch(getForWeb(onError));
    }
  }, [dispatch, setting]);

  useEffect(() => {
    if (!resourceBundle) {
      dispatch(getResourceBundle());
    }
  }, [dispatch, resourceBundle]);

  useEffect(() => {
    dispatch(getCustomer());
  }, [dispatch]);

  if (isInvalidGateway) {
    return <InvalidGateway />;
  }

  if (!setting) {
    return null;
  }

  let { pathname } = window.location;
  pathname = pathname.replace(/^\/|\/$/g, '');
  const pathArray = pathname.split('/');

  if (pathArray[0] === 'club' && pathArray.length > 1) {
    return <ClubRedirect slug={pathArray[1]} />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LfaKNkgAAAAAK8eObCn0Gu5gRtJjmwNNhUhAqKV"
      language="en"
      useRecaptchaNet="false"
      useEnterprise="true"
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
        nonce: undefined // optional, default undefined
      }}
    >
      <Widgets />
      <ModalListener />
    </GoogleReCaptchaProvider>
  );
};

export default NoApp;
